import * as childSingleActions from './childSingle/actions'
import * as membershipSingleActions from './membershipSingle/actions'
import * as nurserySingleActions from './nurserySingle/actions'

export default {
  ...childSingleActions,
  ...membershipSingleActions,
  ...nurserySingleActions,
}
